module.exports = __webpack_public_path__ + "img/GU.c6f6e66b.png";